/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root.route'
import { Route as TestGraphqlRouteImport } from './routes/test-graphql'
import { Route as MediaRouteRouteImport } from './routes/media.route'
import { Route as LoginRouteRouteImport } from './routes/login.route'
import { Route as IndexRouteRouteImport } from './routes/index.route'
import { Route as MediaIndexRouteRouteImport } from './routes/media/index.route'
import { Route as MediaVideosRouteRouteImport } from './routes/media/videos.route'
import { Route as MediaPhonicsRouteRouteImport } from './routes/media/phonics.route'
import { Route as MediaImagesRouteRouteImport } from './routes/media/images.route'
import { Route as MediaFilesRouteRouteImport } from './routes/media/files.route'
import { Route as MediaAudioRouteRouteImport } from './routes/media/audio.route'
import { Route as MediaVideosTrashRouteRouteImport } from './routes/media/videos.trash.route'
import { Route as MediaPhonicsTrashRouteRouteImport } from './routes/media/phonics.trash.route'
import { Route as MediaImagesTrashRouteRouteImport } from './routes/media/images.trash.route'
import { Route as MediaFilesTrashRouteRouteImport } from './routes/media/files.trash.route'
import { Route as MediaAudioTrashRouteRouteImport } from './routes/media/audio.trash.route'

const TestGraphqlRoute = TestGraphqlRouteImport.update({
  id: '/test-graphql',
  path: '/test-graphql',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaRouteRoute = MediaRouteRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRouteRoute = LoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRouteRoute = IndexRouteRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaIndexRouteRoute = MediaIndexRouteRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MediaRouteRoute,
} as any)
const MediaVideosRouteRoute = MediaVideosRouteRouteImport.update({
  id: '/videos',
  path: '/videos',
  getParentRoute: () => MediaRouteRoute,
} as any)
const MediaPhonicsRouteRoute = MediaPhonicsRouteRouteImport.update({
  id: '/phonics',
  path: '/phonics',
  getParentRoute: () => MediaRouteRoute,
} as any)
const MediaImagesRouteRoute = MediaImagesRouteRouteImport.update({
  id: '/images',
  path: '/images',
  getParentRoute: () => MediaRouteRoute,
} as any)
const MediaFilesRouteRoute = MediaFilesRouteRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => MediaRouteRoute,
} as any)
const MediaAudioRouteRoute = MediaAudioRouteRouteImport.update({
  id: '/audio',
  path: '/audio',
  getParentRoute: () => MediaRouteRoute,
} as any)
const MediaVideosTrashRouteRoute = MediaVideosTrashRouteRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => MediaVideosRouteRoute,
} as any)
const MediaPhonicsTrashRouteRoute = MediaPhonicsTrashRouteRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => MediaPhonicsRouteRoute,
} as any)
const MediaImagesTrashRouteRoute = MediaImagesTrashRouteRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => MediaImagesRouteRoute,
} as any)
const MediaFilesTrashRouteRoute = MediaFilesTrashRouteRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => MediaFilesRouteRoute,
} as any)
const MediaAudioTrashRouteRoute = MediaAudioTrashRouteRouteImport.update({
  id: '/trash',
  path: '/trash',
  getParentRoute: () => MediaAudioRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRouteRoute
  '/login': typeof LoginRouteRoute
  '/media': typeof MediaRouteRouteWithChildren
  '/test-graphql': typeof TestGraphqlRoute
  '/media/audio': typeof MediaAudioRouteRouteWithChildren
  '/media/files': typeof MediaFilesRouteRouteWithChildren
  '/media/images': typeof MediaImagesRouteRouteWithChildren
  '/media/phonics': typeof MediaPhonicsRouteRouteWithChildren
  '/media/videos': typeof MediaVideosRouteRouteWithChildren
  '/media/': typeof MediaIndexRouteRoute
  '/media/audio/trash': typeof MediaAudioTrashRouteRoute
  '/media/files/trash': typeof MediaFilesTrashRouteRoute
  '/media/images/trash': typeof MediaImagesTrashRouteRoute
  '/media/phonics/trash': typeof MediaPhonicsTrashRouteRoute
  '/media/videos/trash': typeof MediaVideosTrashRouteRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRouteRoute
  '/login': typeof LoginRouteRoute
  '/test-graphql': typeof TestGraphqlRoute
  '/media/audio': typeof MediaAudioRouteRouteWithChildren
  '/media/files': typeof MediaFilesRouteRouteWithChildren
  '/media/images': typeof MediaImagesRouteRouteWithChildren
  '/media/phonics': typeof MediaPhonicsRouteRouteWithChildren
  '/media/videos': typeof MediaVideosRouteRouteWithChildren
  '/media': typeof MediaIndexRouteRoute
  '/media/audio/trash': typeof MediaAudioTrashRouteRoute
  '/media/files/trash': typeof MediaFilesTrashRouteRoute
  '/media/images/trash': typeof MediaImagesTrashRouteRoute
  '/media/phonics/trash': typeof MediaPhonicsTrashRouteRoute
  '/media/videos/trash': typeof MediaVideosTrashRouteRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRouteRoute
  '/login': typeof LoginRouteRoute
  '/media': typeof MediaRouteRouteWithChildren
  '/test-graphql': typeof TestGraphqlRoute
  '/media/audio': typeof MediaAudioRouteRouteWithChildren
  '/media/files': typeof MediaFilesRouteRouteWithChildren
  '/media/images': typeof MediaImagesRouteRouteWithChildren
  '/media/phonics': typeof MediaPhonicsRouteRouteWithChildren
  '/media/videos': typeof MediaVideosRouteRouteWithChildren
  '/media/': typeof MediaIndexRouteRoute
  '/media/audio/trash': typeof MediaAudioTrashRouteRoute
  '/media/files/trash': typeof MediaFilesTrashRouteRoute
  '/media/images/trash': typeof MediaImagesTrashRouteRoute
  '/media/phonics/trash': typeof MediaPhonicsTrashRouteRoute
  '/media/videos/trash': typeof MediaVideosTrashRouteRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/media'
    | '/test-graphql'
    | '/media/audio'
    | '/media/files'
    | '/media/images'
    | '/media/phonics'
    | '/media/videos'
    | '/media/'
    | '/media/audio/trash'
    | '/media/files/trash'
    | '/media/images/trash'
    | '/media/phonics/trash'
    | '/media/videos/trash'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/test-graphql'
    | '/media/audio'
    | '/media/files'
    | '/media/images'
    | '/media/phonics'
    | '/media/videos'
    | '/media'
    | '/media/audio/trash'
    | '/media/files/trash'
    | '/media/images/trash'
    | '/media/phonics/trash'
    | '/media/videos/trash'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/media'
    | '/test-graphql'
    | '/media/audio'
    | '/media/files'
    | '/media/images'
    | '/media/phonics'
    | '/media/videos'
    | '/media/'
    | '/media/audio/trash'
    | '/media/files/trash'
    | '/media/images/trash'
    | '/media/phonics/trash'
    | '/media/videos/trash'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRouteRoute: typeof IndexRouteRoute
  LoginRouteRoute: typeof LoginRouteRoute
  MediaRouteRoute: typeof MediaRouteRouteWithChildren
  TestGraphqlRoute: typeof TestGraphqlRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/test-graphql': {
      id: '/test-graphql'
      path: '/test-graphql'
      fullPath: '/test-graphql'
      preLoaderRoute: typeof TestGraphqlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media': {
      id: '/media'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof MediaRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media/': {
      id: '/media/'
      path: '/'
      fullPath: '/media/'
      preLoaderRoute: typeof MediaIndexRouteRouteImport
      parentRoute: typeof MediaRouteRoute
    }
    '/media/videos': {
      id: '/media/videos'
      path: '/videos'
      fullPath: '/media/videos'
      preLoaderRoute: typeof MediaVideosRouteRouteImport
      parentRoute: typeof MediaRouteRoute
    }
    '/media/phonics': {
      id: '/media/phonics'
      path: '/phonics'
      fullPath: '/media/phonics'
      preLoaderRoute: typeof MediaPhonicsRouteRouteImport
      parentRoute: typeof MediaRouteRoute
    }
    '/media/images': {
      id: '/media/images'
      path: '/images'
      fullPath: '/media/images'
      preLoaderRoute: typeof MediaImagesRouteRouteImport
      parentRoute: typeof MediaRouteRoute
    }
    '/media/files': {
      id: '/media/files'
      path: '/files'
      fullPath: '/media/files'
      preLoaderRoute: typeof MediaFilesRouteRouteImport
      parentRoute: typeof MediaRouteRoute
    }
    '/media/audio': {
      id: '/media/audio'
      path: '/audio'
      fullPath: '/media/audio'
      preLoaderRoute: typeof MediaAudioRouteRouteImport
      parentRoute: typeof MediaRouteRoute
    }
    '/media/videos/trash': {
      id: '/media/videos/trash'
      path: '/trash'
      fullPath: '/media/videos/trash'
      preLoaderRoute: typeof MediaVideosTrashRouteRouteImport
      parentRoute: typeof MediaVideosRouteRoute
    }
    '/media/phonics/trash': {
      id: '/media/phonics/trash'
      path: '/trash'
      fullPath: '/media/phonics/trash'
      preLoaderRoute: typeof MediaPhonicsTrashRouteRouteImport
      parentRoute: typeof MediaPhonicsRouteRoute
    }
    '/media/images/trash': {
      id: '/media/images/trash'
      path: '/trash'
      fullPath: '/media/images/trash'
      preLoaderRoute: typeof MediaImagesTrashRouteRouteImport
      parentRoute: typeof MediaImagesRouteRoute
    }
    '/media/files/trash': {
      id: '/media/files/trash'
      path: '/trash'
      fullPath: '/media/files/trash'
      preLoaderRoute: typeof MediaFilesTrashRouteRouteImport
      parentRoute: typeof MediaFilesRouteRoute
    }
    '/media/audio/trash': {
      id: '/media/audio/trash'
      path: '/trash'
      fullPath: '/media/audio/trash'
      preLoaderRoute: typeof MediaAudioTrashRouteRouteImport
      parentRoute: typeof MediaAudioRouteRoute
    }
  }
}

interface MediaAudioRouteRouteChildren {
  MediaAudioTrashRouteRoute: typeof MediaAudioTrashRouteRoute
}

const MediaAudioRouteRouteChildren: MediaAudioRouteRouteChildren = {
  MediaAudioTrashRouteRoute: MediaAudioTrashRouteRoute,
}

const MediaAudioRouteRouteWithChildren = MediaAudioRouteRoute._addFileChildren(
  MediaAudioRouteRouteChildren,
)

interface MediaFilesRouteRouteChildren {
  MediaFilesTrashRouteRoute: typeof MediaFilesTrashRouteRoute
}

const MediaFilesRouteRouteChildren: MediaFilesRouteRouteChildren = {
  MediaFilesTrashRouteRoute: MediaFilesTrashRouteRoute,
}

const MediaFilesRouteRouteWithChildren = MediaFilesRouteRoute._addFileChildren(
  MediaFilesRouteRouteChildren,
)

interface MediaImagesRouteRouteChildren {
  MediaImagesTrashRouteRoute: typeof MediaImagesTrashRouteRoute
}

const MediaImagesRouteRouteChildren: MediaImagesRouteRouteChildren = {
  MediaImagesTrashRouteRoute: MediaImagesTrashRouteRoute,
}

const MediaImagesRouteRouteWithChildren =
  MediaImagesRouteRoute._addFileChildren(MediaImagesRouteRouteChildren)

interface MediaPhonicsRouteRouteChildren {
  MediaPhonicsTrashRouteRoute: typeof MediaPhonicsTrashRouteRoute
}

const MediaPhonicsRouteRouteChildren: MediaPhonicsRouteRouteChildren = {
  MediaPhonicsTrashRouteRoute: MediaPhonicsTrashRouteRoute,
}

const MediaPhonicsRouteRouteWithChildren =
  MediaPhonicsRouteRoute._addFileChildren(MediaPhonicsRouteRouteChildren)

interface MediaVideosRouteRouteChildren {
  MediaVideosTrashRouteRoute: typeof MediaVideosTrashRouteRoute
}

const MediaVideosRouteRouteChildren: MediaVideosRouteRouteChildren = {
  MediaVideosTrashRouteRoute: MediaVideosTrashRouteRoute,
}

const MediaVideosRouteRouteWithChildren =
  MediaVideosRouteRoute._addFileChildren(MediaVideosRouteRouteChildren)

interface MediaRouteRouteChildren {
  MediaAudioRouteRoute: typeof MediaAudioRouteRouteWithChildren
  MediaFilesRouteRoute: typeof MediaFilesRouteRouteWithChildren
  MediaImagesRouteRoute: typeof MediaImagesRouteRouteWithChildren
  MediaPhonicsRouteRoute: typeof MediaPhonicsRouteRouteWithChildren
  MediaVideosRouteRoute: typeof MediaVideosRouteRouteWithChildren
  MediaIndexRouteRoute: typeof MediaIndexRouteRoute
}

const MediaRouteRouteChildren: MediaRouteRouteChildren = {
  MediaAudioRouteRoute: MediaAudioRouteRouteWithChildren,
  MediaFilesRouteRoute: MediaFilesRouteRouteWithChildren,
  MediaImagesRouteRoute: MediaImagesRouteRouteWithChildren,
  MediaPhonicsRouteRoute: MediaPhonicsRouteRouteWithChildren,
  MediaVideosRouteRoute: MediaVideosRouteRouteWithChildren,
  MediaIndexRouteRoute: MediaIndexRouteRoute,
}

const MediaRouteRouteWithChildren = MediaRouteRoute._addFileChildren(
  MediaRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRouteRoute: IndexRouteRoute,
  LoginRouteRoute: LoginRouteRoute,
  MediaRouteRoute: MediaRouteRouteWithChildren,
  TestGraphqlRoute: TestGraphqlRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
